import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PersonClient } from '@models/clients';
import { ClientsDispatch } from '@state/clients';
import { MatterClientDispatch } from '@state/matter_clients/matterClients.dispatch';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-person-client-side-form',
	templateUrl: './edit-person-client-side-form.component.html',
	standalone: false,
})
export class EditPersonClientSideFormComponent implements OnInit {
	@Input() client: PersonClient;
	@Input() showPrimaryClientOption = false;
	@Input() primaryContact;
	public showIDsOption = false;
	public showRepresentationOption = true;
	private isPrimary: boolean;

	constructor(
		private navigationService: NavigationService,
		private matterClientDispatch: MatterClientDispatch,
		private route: ActivatedRoute,
		private clientsDispatch: ClientsDispatch,
	) {}

	ngOnInit(): void {
		this.isPrimary = this.primaryContact;
	}

	_onCreate(client: PersonClient & { primary: boolean }) {
		this.clientsDispatch.CreateOrMerge(this.client.id, {
			firstName: client.firstName,
			middleNames: client.middleNames,
			lastName: client.lastName,
			email: client.email ?? null,
			phone: client.phone,
			title: client.title ?? null,
			representation: client.representation,
			gender: client.gender ?? null,
			dateOfBirth: client.dateOfBirth ?? null,
		});

		if (client.primary !== this.isPrimary) {
			this.matterClientDispatch.SetIsPrimary(this.client.id, client.primary);
		}

		this.navigationService.goBack(this.route);
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
